const meals = [
    {
        id: 1,
        name: `М'сне асорті "Спадщина"`,
        description: `Балик холодного копчення, шинка сирого копчення, ковбаса московська, куряча грудка вареного копчення`,
        price: 11.99
    },
    {
        id: 2,
        name: `"Гранатова Грація" Ягняче Каре в Соусі`,
        description: `Ягня, олія, гранат, мед, спеції`,
        price: 3.99
    },
    {
        id: 3,
        name: `Кентукі`,
        description: ` Свинячі ребра, мед, гірчиця, цедра апильсну`,
        price: 11.99
    },
    {
        id: 4,
        name: `Салат "Поке з лососем "Медова дуель"`,
        description: `Курячі крильця в меді та спеціях`,
        price: 11.99
    }

]
export default meals